<template>
  <div class="lnb-wrap">
    <div class="outline-box">
      <div v-for="(category, index) in menuCategroies" :key="index" class="categories">
        <p class="category-title" :class="{ active: isActiveCategory(category)}">{{ category.title }}</p>
        <ul>
          <li v-for="(item, itemIndex) in category.items" :key="itemIndex">
            <NuxtLink :to="item.link" :class="{ active: isActiveMenu(item.link) }">{{ item.text }}</NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

import { useRoute } from 'vue-router';

const route = useRoute();

const isActiveCategory = (category: MenuCategory) => {
  return category.items.some(item => route.path === item.link)
}

const isActiveMenu = (menuPath: string) => {
  return (
    route.path === menuPath || route.path.startsWith(menuPath + '/')
  )
}

interface MenuItem {
  link: string,
  text: string
}
interface MenuCategory {
  title: string,
  items: MenuItem[]
}

const menuCategroies: MenuCategory[] = [
  { 
    title: '주문관리', 
    items: [
      { link: '/pc/mypage/order', text: '구매관리'},
      { link: '/pc/mypage/pin-publication-request', text: '핀발행 요청 관리'},
    ],
  },
  { 
    title: '결제관리', 
    items: [
      { link: '/pc/mypage/hcash', text: 'H캐시 관리'},
      { link: '/pc/mypage/mileage', text: '적립금 관리'},
      { link: '/pc/mypage/account', text: '계좌 관리'},
    ],
  },
  {
    title: '쿠폰 발송 관리',
    items: [
      // { link: '/pc/mypage/sender', text: '발신번호 관리'}, 
      { link: '/pc/mypage/coupon-top-image', text: '쿠폰 상단 이미지 관리'}, 
      { link: '/pc/mypage/coupon-message', text: '쿠폰 메시지 관리'}, 
      { link: '/pc/mypage/receive-person', text: '연락처 관리'}
    ]
  },
  { 
    title: '나의 정보 관리', 
    items: [
      { link: '/pc/mypage/information', text: '회원 정보 관리'}
    ]
  },
];

</script>

<style lang="scss" scoped>
@use "@/assets/scss/pc/mypage-hcon.scss" as *;

</style>